module.exports = "/assets/data/bab56f66ddb88dec0d3ccb5608984e01-NE5.data.json";